import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, UL } from '../../../../AbstractElements';
import UploadMonthlySalesView from './uploadMonthlySales';
import { Container } from 'reactstrap';

const UploadMonthlySales = () => {
    const { t } = useTranslation();
    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent={t('Audit')} title={t('Upload Monthly Sales')} mainTitle={t('Upload Monthly Sales')} />
                <Container fluid={true}>
                    <UploadMonthlySalesView />
                </Container>
            </Fragment>
        </UL>
    )
}

export default UploadMonthlySales